<template>
	<div :class="{ dark: darkMode.enabled }">
		<div
			class="relative from-white to-slate-50 bg-gradient-to-br dark:from-white dark:to-white dark:selection:bg-gray-400 dark:text-gray-400 w-full min-h-screen font-gilroy"
		>
			<Nav class="print:hidden" />

			<Breadcrumbs />

			<RouterView v-slot="{ Component, route }" @navHidden="navHidden = $event">
				<Suspense :timeout="200">
					<Component :is="Component" :key="route.meta.usePathKey ? route.path : undefined" />
					<template #fallback><spinner /></template>
				</Suspense>
			</RouterView>

			<Footer class="print:hidden" />

			<CartValidation v-model:showCartValidationModal="showCartValidationModal" :oosItems="oosItems" :lowStockItems="lowStockItems" />
		</div>
	</div>
</template>

<script>
import Logo from './components/partials/logo.vue'
import FooterLogo from './components/partials/footer-logo.vue'
import YMALBag from './components/pages/ihh-items/ymal-bag.vue'
import Shipping from './components/pages/ihh-items/shipping.vue'
import Nav from './components/layout/nav.vue'
import Breadcrumbs from './components/layout/breadcrumbs.vue'
import Footer from './components/layout/footer.vue'
import Mango from './helpers/mango'
import CartValidation from './components/layout/cart-validation.vue'
import { validateInventory } from './helpers/validateCart.js'
export default {
	components: { Logo, FooterLogo, YMALBag, Shipping, Nav, Breadcrumbs, Footer, CartValidation },
	inject: ['store', 'darkMode', 'checkout'],
	data() {
		return {
			oosItems: [],
			lowStockItems: [],
			showCartValidationModal: false,
		}
	},
	watch: {
		loggedIn: {
			immediate: true,
			handler() {
				if (this.loggedIn) {
					this.fetchWishlists()
				}
			},
		},
	},
	methods: {
		setRecentlyViewed() {
			let recentlyViewed = JSON.parse(sessionStorage.getItem('recentlyViewed')) || []
			this.store.recentlyViewed = recentlyViewed
		},
		async fetchWishlists() {
			let wishlists = await Mango.wishlists({ search: { author: this.store.user.id } })
			this.store.wishlists = wishlists
		},
	},
	async mounted() {
		const guest = JSON.parse(sessionStorage.getItem('guest')) || {}
		if (Object.keys(guest).length) this.checkout.guest = guest

		const addresses = JSON.parse(sessionStorage.getItem('addresses')) || []
		if (addresses.length) this.checkout.addresses = addresses
		const shipping = JSON.parse(sessionStorage.getItem('shipping')) || {}
		if (Object.keys(shipping).length) this.checkout.shipping = shipping

		const billing = JSON.parse(sessionStorage.getItem('billing')) || {}
		if (Object.keys(billing).length) this.checkout.billing = billing
		this.setRecentlyViewed()

		// Wait 2 seconds and then validate cart items' inventory
		await new Promise((resolve) => setTimeout(resolve, 2000))
		const { oosItems, lowStockItems } = await validateInventory()
		this.oosItems = oosItems
		this.lowStockItems = lowStockItems

		if (this.oosItems.length > 0 || this.lowStockItems.length > 0) {
			this.showCartValidationModal = true
		}
	},
	computed: {
		loggedIn() {
			return this.store?.user?.id
		},
	},
}
</script>
<style lang="postcss">
.gradient {
	@apply bg-gradient-to-b from-ihh-pink to-ihh-purple;
}
@font-face {
	font-family: 'Gilroy';
	src: url('https://cdn11.bigcommerce.com/s-nuj3c/content/fonts/gilroy-regular.woff') format('woff');
	font-weight: 400;
	font-style: normal;
}
@font-face {
	font-family: 'Gilroy';
	src: url('https://cdn11.bigcommerce.com/s-nuj3c/content/fonts/gilroy-medium.woff') format('woff');
	font-weight: 500;
	font-style: normal;
}
@font-face {
	font-family: 'Gilroy';
	src: url('https://cdn11.bigcommerce.com/s-nuj3c/content/fonts/gilroy-semibold.woff') format('woff');
	font-weight: 600;
	font-style: normal;
}
@font-face {
	font-family: 'Gilroy';
	src: url('https://cdn11.bigcommerce.com/s-nuj3c/content/fonts/gilroy-bold.woff') format('woff');
	font-weight: 700;
	font-style: normal;
}

#chat-button {
	@apply !z-20;
}

/* For most browsers */
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* For Firefox */
input[type='number'] {
	-moz-appearance: textfield;
}

.prose > h1,
.prose > h2,
.prose > h3 {
	color: #494949;
}


</style>
